export default {
      id: "oc-bigger-usage",
      viewBox: "0 0 1026 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-bigger",
      toString: function () {
        return this.url;
      }
    }